<template>
  <div
    ref="periodSelectorRef"
    role="listbox"
    data-cy="ds-datepicker__period-selector"
    :class="`${DS_DATEPICKER_CLASSES.PeriodSelector} ${DS_DATEPICKER_PERIOD_SELECTOR_CLASSES_MAP[props.type]}`"
  >
    <div
      v-for="option in props.options"
      :key="`${props.type}-${option.value}`"
      :data-cy="`ds-datepicker__period-option--${props.type}-${option.value}`"
      :class="{
        [DS_DATEPICKER_CLASSES.PeriodOption]: true,
        [DS_DATEPICKER_CLASSES.PeriodOptionSelected]: props.selectedValue === option.value,
      }"
    >
      <DSButton
        :ref="el => setButtonRef(el as InstanceType<typeof DSButton>, option.value)"
        data-cy="ds-datepicker__period-option-button"
        :variant="option.value === props.selectedValue ? 'primary' : 'ghost'"
        size="lg"
        role="option"
        :aria-selected="option.value === props.selectedValue"
        @click="emit('select:option', option.value)"
      >
        {{ option.text }}
      </DSButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import {
  DSDatePickerPeriodSelectorEmits,
  DSDatePickerPeriodSelectorProps,
} from "@/src/design_system/form_elements/datepicker/types/periodSelector";
import { onMounted, ref } from "vue";
import { useScrollToSelectedPeriodOption } from "@/src/design_system/form_elements/datepicker/composables/scrollToSelectedPeriodOption";
import {
  DS_DATEPICKER_CLASSES,
  DS_DATEPICKER_PERIOD_SELECTOR_CLASSES_MAP,
} from "@/src/design_system/form_elements/datepicker/constants/classes";

const props = withDefaults(defineProps<DSDatePickerPeriodSelectorProps>(), {
  selectedValue: undefined,
});

const emit = defineEmits<DSDatePickerPeriodSelectorEmits>();

const periodSelectorRef = ref<HTMLDivElement | null>(null);

const { scrollToSelected, setButtonRef } = useScrollToSelectedPeriodOption({
  selectedValue: props.selectedValue,
  periodSelectorRef,
});

onMounted(() => {
  scrollToSelected();
});
</script>
